import { ConfirmAction } from "../types";
import React from "react";
import { Box, Typography } from "@mui/material";

export function computeMutation(action: ConfirmAction) {
  if (action === "save") {
    return (
      <Box>
        <Typography variant={"h5"}>User data will be saved.</Typography>
        <br />
        <Typography variant="body1">
          If the edited user is an admin, it means that they can see all
          regions, regardless of the one selected in the Admin Panel.
        </Typography>
      </Box>
    );
  }

  if (action === "delete") {
    return <Typography variant="h4">User data will be deleted.</Typography>;
  }

  return null;
}
